import * as React from "react";
function SvgAlcmeonUntinted(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g stroke="currentColor" strokeWidth={1.93} fill="none">
        <path d="M22.31 25.06C26 22.87 29 18.93 29 14.3 29 7.5 23.19 2 16 2S3 7.5 3 14.3a12.28 12.28 0 008 11.34L9.09 30s9.73-2.89 13.22-4.94z" />
        <path d="M22 16.21a6.34 6.34 0 01-6 4 6.34 6.34 0 01-6-3.91" />
      </g>
      <circle cx={12.75} cy={10.24} r={1.42} />
      <circle cx={19.25} cy={10.24} r={1.42} />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgAlcmeonUntinted);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
